import './MatchGameFilters.scss';

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  filterMatchGameProfiles,
  getMatchGameFilters,
  setMatchGameFilters,
} from '../../services/profile-service/profile.service.js';
import Button from '../Button/Button';

const MatchGameFilters = (props) => {
  const { closeModal, modalRef, setFilteredData, setGameProfile, setNextProfileUrl } = props;
  const filters = getMatchGameFilters();
  const min = 18;
  const max = 100;
  const submitRef = useRef();
  const [ageInterval, setAgeInterval] = useState();
  const hairColors = useSelector((state) => state.staticData.hairColors);
  const bodyTypes = useSelector((state) => state.staticData.bodyTypes);
  const [hairColor, setHairColor] = useState();
  const [bodyType, setBodyType] = useState();
  const [minVal, setMinVal] = useState(filters?.minVal || min);
  const [maxVal, setMaxVal] = useState(filters?.maxVal || max);
  const minValRef = useRef(filters?.minVal || min);
  const maxValRef = useRef(filters?.maxVal || max);
  const range = useRef(null);

  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  const closeMatchFilters = () => {
    closeModal(modalRef);
  };

  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }

    //setMinVal(filters?.minVal)
    //setMaxVal(filters?.maxVal)
  }, [filters]);

  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    console.log(minPercent, 'MIN');
    console.log(maxPercent, 'MAX');
    console.log(minVal);
    console.log(filters?.minVal);
    console.log(min);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }

    console.log(minPercent, 'MIN');
    console.log(maxPercent, 'MAX');
  }, [maxVal, getPercent]);

  const sanitizeFilterParameters = useCallback((params) => {
    params.forEach((p) => {
      if (!p.value) {
        delete p.value;
      }
    });
  }, []);

  useEffect(() => {
    if (filters?.hairColor) {
      setHairColor(filters.hairColor);
    }

    if (filters?.bodyType) {
      setBodyType(filters.bodyType);
    }

    if (filters?.minVal) {
      setMinVal(filters.minVal);
    }

    if (filters?.maxVal) {
      setMaxVal(filters.maxVal);
    }
  });

  const handleSearch = useCallback(async () => {
    try {
      const res = await filterMatchGameProfiles([
        {
          key: 'hair_color',
          value: hairColor,
        },
        {
          key: 'body_build',
          value: bodyType,
        },
        {
          key: 'age_between',
          value: [minVal, maxVal],
        },
      ]);

      setGameProfile(res.data.data[0]);
      setNextProfileUrl(res.data.links?.next?.split('?')[1]);

      let parameters = [
        {
          key: 'hair_color',
          value: hairColor,
        },
        {
          key: 'body_build',
          value: bodyType,
        },
        {
          key: 'age_between',
          value: [minVal, maxVal],
        },
      ];

      sanitizeFilterParameters(parameters);
      setFilteredData(true);
      closeMatchFilters();
    } catch (e) {
      console.log(e);
    }
  }, [hairColor, bodyType, minVal, maxVal]);

  const handleHairColorFilter = useCallback((e) => {
    setHairColor(e.target.value);
    setMatchGameFilters({ ...filters, hairColor: e.target.value });
  }, []);

  const handleBodyTypeFilter = useCallback((e) => {
    setBodyType(e.target.value);
    setMatchGameFilters({ ...filters, bodyType: e.target.value });
  }, []);

  const handleAgeIntervalFilter = useCallback(({ min, max }) => {
    setAgeInterval({ min, max });
  }, []);

  return (
    <div className="MatchGame-Modal">
      <h4 className="MatchGame-Header">Match Game Settings</h4>
      <div className="Filters-Wrapper">
        <div className="AgeRange">
          <div className="HeaderNumbers">
            <p className="AgeRangeSlider">Age Range</p>
            <div className="AgeRangeSliderNumbers">
              {minVal} - {maxVal}
            </div>
          </div>

          <input
            type="range"
            min={min}
            max={max}
            value={minVal}
            onChange={(event) => {
              const value = Math.min(Number(event.target.value), maxVal - 1);
              setMinVal(value);
              setMatchGameFilters({ ...filters, minVal: value });
              minValRef.current = value;
            }}
            className="Thumb ThumbLeft"
            style={{ zIndex: minVal > max - 100 && '5' }}
          />
          <input
            type="range"
            min={min}
            max={max}
            value={maxVal}
            onChange={(event) => {
              const value = Math.max(Number(event.target.value), minVal + 1);
              setMaxVal(value);
              setMatchGameFilters({ ...filters, maxVal: value });
              maxValRef.current = value;
            }}
            className="Thumb ThumbRight"
          />

          <div className="slider">
            <div className="SliderTrack" />
            <div ref={range} className="SliderRange" />
          </div>
        </div>
        <div className="HairColor">
          <label htmlFor="hair-color">Hair Color</label>
          <select className="HairOption" value={hairColor} onChange={handleHairColorFilter}>
            <option value="">-- Select --</option>
            {hairColors.map((item) => {
              return (
                <option className="To-Uppercase" value={item.name} key={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="BodyType">
          <label htmlFor="body-type">Body Type</label>
          <select className="BodyOption" value={bodyType} onChange={handleBodyTypeFilter}>
            <option value="">-- Select --</option>
            {bodyTypes.map((item) => {
              return (
                <option className="BodyOption" value={item.name} key={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <Button onClick={handleSearch} bodyType={bodyType} hairColor={hairColor} text="UPDATE" />
    </div>
  );
};

export default MatchGameFilters;
